/** User-facing text for this area. Edit here; the German file is typed against this one. */
export const enHost = {
  "h.title": "Host stand",
  "h.nearby": "Nearby: {times}",
  "h.pc.title": "Restaurant passcode",
  "h.pc.body": "This action is protected. Enter the restaurant passcode to continue.",
  "h.pc.aria": "Passcode",
  "h.pc.wrong": "Incorrect passcode. Try again.",
  "h.continue": "Continue",
  "h.login.doc": "Sign in · Host stand",
  "h.login.sub": "Sign in with your staff account.",
  "h.login.twostep": "Two-step sign-in",
  "h.login.code_label": "Authentication code",
  "h.login.code_hint": "Enter the 6-digit code from your authenticator app, or a recovery code.",
  "h.login.verify": "Verify",
  "h.login.other_account": "Use a different account",
  "h.login.one_more": "One more step.",
  "h.login.email": "Email",
  "h.login.reset_link": "Email me a reset link",
  "h.login.back": "Back to sign in",
  "h.login.reset_title": "Reset your password",
  "h.login.reset_sub": "We will email a link if the address belongs to an account.",
  "h.login.new_pass": "New password (10+ characters)",
  "h.login.set_pass": "Set password",
  "h.login.choose_title": "Choose a new password",
  "h.login.once": "This link works once.",
  "h.login.sso": "Sign in with single sign-on",
  "h.login.sso_enforced": "Your restaurant requires single sign-on. Only the Owner can use a password.",
  "h.login.or_password": "Or use your password:",
  "h.login.password": "Password",
  "h.login.submit": "Sign in",
  "h.login.forgot": "Forgot your password?",
  "h.login.session_ended": "Your session ended. Please sign in again.",
  "h.login.mfa_title": "Set up two-step sign-in",
  "h.login.mfa_body": "Your restaurant requires it before you can continue.",
  "h.login.reset_sent": "If that address belongs to an account, a reset link is on its way.",
  "h.login.pass_changed": "Password changed. You can sign in now.",
  "h.login.bad_code": "That code is not right.",
  "h.login.bad_creds": "Incorrect email, password or code.",
  "h.date_aria": "Date",
  "h.prev_day": "Previous day",
  "h.today": "Today",
  "h.next_day": "Next day",
  "h.shift_aria": "Shift",
  "h.closed": "Closed",
  "h.covers": "{n} covers",
  "h.view_aria": "View",
  "h.view.floor": "Floor",
  "h.view.list": "List",
  "h.view.timeline": "Timeline",
  "h.view.overview": "Overview",
  "h.view.calendar": "Calendar",
  "h.book": "+ Book",
  "h.waitlist_add": "+ Waitlist",
  "h.statuses": "Statuses",
  "h.statuses_title": "Status management",
  "h.config": "Configuration",
  "h.config_title": "Shifts, tables, policies (draft and publish)",
  "h.team": "Team",
  "h.team_title": "Staff, roles and passcode",
  "h.security": "Security",
  "h.security_title": "Two-step sign-in and password",
  "h.sign_out": "Sign out",
  "h.table_n": "Table {label}",
  "h.unassigned": "Unassigned",
  "h.not_assigned": "Not assigned",
  "h.wait.progress": "{waited}m of {quoted}m",
  "h.wait.notified": "notified",
  "h.group.waitlist": "Waitlist",
  "h.group.reservations": "Reservations",
  "h.group.seated": "Seated",
  "h.group.finished": "Finished",
  "h.group.removed": "Removed",
  "h.parties_aria": "Parties",
  "h.none": "None",
  "h.tbl.blocked": "blocked",
  "h.tbl.held": "held",
  "h.tbl.aria": "Table {label}, {state}",
  "h.tbl.free": "free",
  "h.party_fallback": "party",
  "h.banner.seat": "Seat {name}: choose a table",
  "h.banner.assign": "Pre-assign {name}: choose a table",
  "h.banner.move": "Move {name}: choose the new table",
  "h.banner.waitseat": "Seat waitlist party: choose a table",
  "h.banner.walkin": "Seat walk-in of {n}: choose a table",
  "h.tl.no_shift": "No shift on this day.",
  "h.tl.blocked": "Blocked",
  "h.tl.booked": "Booked",
  "h.tl.table": "Table",
  "h.tl.covers": "Covers",
  "h.tl.cap": "/cap",
  "h.tl.cell_title": "{c} covers of {m}, {p} parties",
  "h.tl.cell_title_free": "{c} covers, {p} parties",
  "h.ov.no_data": "No data.",
  "h.ov.shift": "Shift",
  "h.ov.covers": "Covers",
  "h.ov.booked": "Booked",
  "h.ov.seated": "Seated",
  "h.ov.waitlist": "Waitlist",
  "h.ov.by_time": "Covers by time",
  "h.ov.by_source": "Covers by source",
  "h.ov.by_size": "Parties by size",
  "h.ov.servers": "Server sections",
  "h.source.website": "Website",
  "h.source.network": "Network",
  "h.source.phone": "Phone",
  "h.source.host": "Host stand",
  "h.source.walk_in": "Walk-in",
  "h.d.aria": "Party details",
  "h.d.status": "Status",
  "h.d.table": "Table",
  "h.d.duration": "Duration",
  "h.d.elapsed": "{time} elapsed",
  "h.d.phone": "Phone",
  "h.d.occasion": "Occasion",
  "h.d.request": "Request",
  "h.d.policy": "Policy",
  "h.d.payment": "Payment",
  "h.d.code": "Code",
  "h.policy.card_hold": "card hold",
  "h.policy.deposit": "deposit",
  "h.a.seat_now": "Seat now",
  "h.a.seat": "Seat…",
  "h.a.preassign": "Pre-assign",
  "h.a.move": "Move table",
  "h.a.finish": "Finish",
  "h.a.edit": "Edit",
  "h.a.noshow": "No-show",
  "h.a.cancel": "Cancel",
  "h.d.exclude": "Exclude from pacing limit",
  "h.d.excluded": "Excluded from pacing limit",
  "h.d.emails": "Guest emails",
  "h.d.resend": "Resend confirmation",
  "h.d.notes": "Notes",
  "h.d.no_notes": "No notes",
  "h.pay.pending": "Waiting for card",
  "h.pay.card_saved": "Card on file",
  "h.pay.deposit_paid": "Deposit paid {amount}",
  "h.pay.fee_collected": "Fee collected",
  "h.pay.forfeited": "Deposit kept {amount}",
  "h.pay.released": "Card released",
  "h.pay.refunded": "Deposit refunded",
  "h.pay.failed": "Payment failed",
  "h.pay.canceled": "Payment cancelled",
  "h.pay.fee_due": "Fee due {amount}",
  "h.pay.charge": "Charge fee",
  "h.pay.refund_pending": "Refund pending {amount}",
  "h.pay.refund": "Refund",
  "h.w.aria": "Waitlist party",
  "h.w.quoted": "Quoted",
  "h.w.waiting": "Waiting",
  "h.w.minutes": "{n}m",
  "h.w.status.waiting": "waiting",
  "h.w.status.notified": "notified",
  "h.w.status.seated": "seated",
  "h.w.status.removed": "removed",
  "h.w.notify": "Notify (table ready)",
  "h.w.seat": "Seat…",
  "h.w.remove": "Remove",
  "h.w.no_permission": "Your role cannot manage the waitlist.",
  "h.t.aria": "Table details",
  "h.t.seats": "{min}–{max} seats",
  "h.t.party": "Party",
  "h.t.elapsed": "Elapsed",
  "h.t.open_party": "Open party",
  "h.t.blocked": "Blocked",
  "h.t.held": "Held for a guest in checkout",
  "h.t.free": "Free",
  "h.t.next": "next booking {time}",
  "h.t.walkin": "Seat walk-in",
  "h.t.block": "Block 1 hour",
  "h.t.no_bookings": "No bookings",
  "h.render_failed": "The screen could not be drawn: {error}",
  "h.em.confirmation": "Confirmation",
  "h.em.reminder": "Reminder",
  "h.em.change": "Change notice",
  "h.em.cancellation": "Cancellation",
  "h.em.sent": "sent {time}",
  "h.em.failed": "failed: {error}",
  "h.em.skipped": "not needed",
  "h.em.queued": "queued for {time}",
  "h.em.none": "No emails yet. The guest may have no email address on file.",
  "h.note.general": "general",
  "h.note.relationship": "relationship",
  "h.note.food_drink": "food & drink",
  "h.note.seating": "seating",
  "h.note.visit": "visit",
  "h.book.title": "Book a table",
  "h.book.date": "Date",
  "h.book.time": "Time",
  "h.book.party": "Party",
  "h.book.find": "Find times",
  "h.book.override": "Override pacing",
  "h.book.override_pass": "Passcode for override",
  "h.book.first": "First name",
  "h.book.last": "Last name",
  "h.book.phone": "Phone",
  "h.book.email": "Email",
  "h.book.request": "Special request",
  "h.book.language": "Guest language",
  "h.book.submit": "Book",
  "h.book.searching": "Searching…",
  "h.book.none": "No availability",
  "h.book.done": "Booked {name} · code {code}",
  "h.wl.title": "Add to waitlist",
  "h.wl.name": "Name",
  "h.wl.name_ph": "Name or description",
  "h.wl.party": "Party size",
  "h.wl.quote": "Quoted wait (min, blank = estimate)",
  "h.wl.phone": "Phone",
  "h.wl.sms": "Text when the table is ready",
  "h.wl.submit": "Add to waitlist",
  "h.wl.quoted": "Quoted {n} min",
  "h.wl.quoted_free": "Quoted {n} min. A table is free right now, so you can seat them straight away.",
  "h.edit.title": "Edit {name}",
  "h.edit.duration": "Duration (minutes)",
  "h.edit.override": "Override pacing when moving",
  "h.edit.saved": "Saved",
  "h.st.title": "Status management",
  "h.st.hint": "Choose which statuses staff can use. Locked statuses are always on.",
  "h.st.locked": "(locked)",
  "h.team.title": "Team",
  "h.team.staff": "Staff",
  "h.team.role_for": "Role for {name}",
  "h.team.active": "Active",
  "h.team.reset_pw": "Reset password",
  "h.team.reset_mfa": "Reset 2-step",
  "h.team.mfa_on": "Two-step sign-in is on",
  "h.team.builtin": "built-in",
  "h.team.custom": "custom",
  "h.team.members_one": "{n} member",
  "h.team.members_other": "{n} members",
  "h.team.no_perms": "No permissions",
  "h.team.policy": "Sign-in policy",
  "h.team.require_mfa": "Require two-step sign-in for everyone who uses a password",
  "h.team.sso": "Single sign-on (OpenID Connect)",
  "h.team.sso_hint": "Register this redirect URI with your identity provider: {uri}. People must already have an account here; nothing is created from the provider.",
  "h.team.issuer": "Issuer URL",
  "h.team.client_id": "Client ID",
  "h.team.client_secret": "Client secret",
  "h.team.keep_blank": "(leave blank to keep)",
  "h.team.domains": "Allowed email domains (comma separated)",
  "h.team.enabled": "Enabled",
  "h.team.enforce": "Require it for everyone except the Owner",
  "h.team.sso_save": "Save single sign-on",
  "h.team.add_person": "Add a person",
  "h.team.name": "Name",
  "h.team.email": "Email",
  "h.team.role": "Role",
  "h.team.initial_pw": "Initial password (10+ characters)",
  "h.team.add_btn": "Add person",
  "h.team.roles": "Roles",
  "h.team.new_role": "New custom role",
  "h.team.role_name": "Role name",
  "h.team.create_role": "Create role",
  "h.team.passcode": "Passcode for protected actions",
  "h.team.pass_set": "A passcode is set.",
  "h.team.pass_unset": "No passcode is set.",
  "h.team.pass_hint": "Blocking tables and overriding pacing ask for it unless the role bypasses it.",
  "h.team.pass_ph": "4 to 8 digits",
  "h.team.pass_new": "New passcode",
  "h.team.set_pass": "Set passcode",
  "h.team.saved": "Saved",
  "h.team.pw_prompt": "New password for this person (10+ characters). They will be signed out everywhere.",
  "h.team.pw_reset_done": "Password reset; their sessions were ended.",
  "h.team.mfa_reset_confirm": "Clear two-step sign-in for this person? They will be signed out and can set it up again.",
  "h.team.sso_saved": "Single sign-on saved.",
  "h.team.sso_remove_confirm": "Remove single sign-on? Password sign-in will apply to everyone again.",
  "h.sec.title": "Account security",
  "h.sec.twostep": "Two-step sign-in",
  "h.sec.save_codes": "Save these recovery codes now.",
  "h.sec.codes_hint": "Each works once if you lose your phone. They will not be shown again.",
  "h.sec.copy": "Copy",
  "h.sec.saved_them": "I have saved them",
  "h.sec.step1": "In your authenticator app choose “Enter a setup key”.",
  "h.sec.step2": "Account: {email}, key:",
  "h.sec.key_aria": "Setup key",
  "h.sec.key_type": "Type: time-based, 6 digits, 30 seconds.",
  "h.sec.enter_code": "Then enter the 6-digit code it shows",
  "h.sec.turn_on": "Turn on",
  "h.sec.is_on": "Two-step sign-in is on.",
  "h.sec.codes_left_one": "{n} recovery code left.",
  "h.sec.codes_left_other": "{n} recovery codes left.",
  "h.sec.password": "Password",
  "h.sec.current_code": "Current code",
  "h.sec.new_codes": "New recovery codes",
  "h.sec.turn_off": "Turn off",
  "h.sec.required": "Your restaurant requires two-step sign-in.",
  "h.sec.add_step": "Add a second step to protect your account.",
  "h.sec.setup": "Set up",
  "h.sec.copied": "Copied.",
  "h.sec.is_off": "Two-step sign-in is off.",
  "h.sec.pw_heading": "Password",
  "h.sec.change_pw": "Change password",
  "h.pw.title": "Change password",
  "h.pw.current": "Current password",
  "h.pw.new": "New password (10+ characters)",
  "h.pw.hint": "You stay signed in here; other devices are signed out.",
  "h.pw.changed": "Password changed",
  "h.walkin.title": "Seat walk-in at table {label}",
  "h.walkin.party": "Party size",
  "h.walkin.name": "Name (optional)",
  "h.walkin.submit": "Seat",
  "role.Owner": "Owner",
  "role.Manager": "Manager",
  "role.Front of house": "Front of house",
  "role.Viewer": "Viewer",
  "perm.host.view": "View the host stand, floor plan and reservation lists",
  "perm.reservations.manage": "Create, change and cancel reservations",
  "perm.host.seat": "Seat parties, change statuses, move tables, add notes",
  "perm.waitlist.manage": "Add, notify, seat and remove waitlist parties",
  "perm.tables.block": "Block tables (protected: needs the restaurant passcode)",
  "perm.pacing.override": "Book past flow controls (protected: needs the restaurant passcode)",
  "perm.settings.manage": "Change booking settings and status management",
  "perm.staff.manage": "Manage staff, roles and the restaurant passcode",
  "perm.protected.bypass": "Skip passcode prompts for protected actions",
  "perm.config.edit": "Edit the draft configuration (shifts, tables, policies)",
  "perm.config.publish": "Publish or restore the configuration so it goes live",
  "perm.payments.manage": "Charge no-show and late-cancellation fees and refund deposits",
  "perm.billing.view": "See and download the invoices for this restaurant's subscription",
  "h.n.type": "Note type",
  "h.n.general": "General",
  "h.n.relationship": "Relationship",
  "h.n.food_drink": "Food & drink",
  "h.n.seating": "Seating",
  "h.n.visit": "Visit",
  "h.n.placeholder": "Add a note",
  "h.n.text": "Note text",
  "h.n.add": "Add note",
  "h.toast.walkin": "Walk-in seated",
  "h.toast.preassigned": "Pre-assigned",
  "h.toast.seated": "Seated",
  "h.toast.moved": "Moved",
  "h.toast.seated_wait": "Seated from waitlist",
  "h.toast.load_day_failed": "Could not load {date}: {error}",
  "h.toast.load_shift_failed": "Could not load that shift: {error}",
  "h.toast.freed": "Table freed",
  "h.confirm.cancel": "Cancel this reservation?",
  "h.toast.cancelled": "Cancelled",
  "h.confirm.noshow": "Mark as no-show?",
  "h.toast.noshow": "Marked no-show",
  "h.toast.blocked": "Blocked for 1 hour",
  "h.toast.queued": "Confirmation queued",
  "h.confirm.charge": "Charge the saved card {amount}?",
  "h.toast.charged": "Charged {amount}",
  "h.toast.charge_pending": "Could not reach the payment provider. Try again shortly; the card is never charged twice.",
  "h.toast.declined": "Card declined: {reason}",
  "h.confirm.refund": "Refund {amount} to the guest’s card?",
  "h.toast.refunded": "Refunded {amount}",
  "h.toast.refund_pending": "Refund could not be completed yet; it will be retried.",
  "h.toast.notified_sms": "Marked notified. SMS delivery is not connected yet, so tell {to} yourself.",
  "h.toast.notified": "Marked notified (no SMS consent, so tell the guest yourself).",
  "h.toast.removed": "Removed",
  "h.toast.status": "Status updated",
  "h.toast.updated": "Updated",
  "h.toast.timeline_hint": "Table {label} at {time}: use + Book for this time",
  "c.title": "Configuration",
  "c.nav_aria": "Configuration sections",
  "c.sec.shifts": "Shifts",
  "c.sec.tables": "Tables",
  "c.sec.layout": "Floor plan",
  "c.sec.policies": "Policies",
  "c.sec.closures": "Closures",
  "c.sec.settings": "Settings",
  "c.sec.branding": "Branding & emails",
  "c.sec.history": "History",
  "c.loading": "Loading…",
  "c.live_initial": "Live (initial)",
  "c.live_v": "Live v{v}",
  "c.changes_one": "{n} unpublished change",
  "c.changes_other": "{n} unpublished changes",
  "c.saving": " · saving…",
  "c.no_draft": "No draft: viewing the live configuration",
  "c.discard": "Discard draft",
  "c.publish": "Publish",
  "c.publishing": "Publishing…",
  "c.publish_needs_perm": "You need the publish permission",
  "c.start_intro": "You are looking at the live configuration. Changes are made in a draft and only go live when you publish.",
  "c.start": "Start editing",
  "c.live_now": "Live now",
  "c.live_shifts": "{n} shifts: {list}",
  "c.live_tables": "{t} tables, {c} combinations",
  "c.live_policies": "{n} policies: {list}",
  "c.live_closures": "{n} closures or special days",
  "c.discard_confirm": "Discard all unpublished changes?",
  "c.published": "Published version {v}",
  "c.restore_confirm": "Replace the current draft with version {v}?",
  "c.review": "Review",
  "c.stale": "The live configuration changed after this draft was started. Restore the latest version as a new draft to continue.",
  "c.no_changes": "No changes yet.",
  "c.fix_first": "Fix before publishing",
  "c.check": "Check these",
  "c.note": "Note for the history",
  "c.note_ph": "What changed and why",
  "c.d.settings": "Settings",
  "c.d.changed_fields": "changed: {list}",
  "c.d.areas": "Areas",
  "c.d.floorPlans": "Floor plans",
  "c.d.tables": "Tables",
  "c.d.features": "Walls and fixtures",
  "c.d.combos": "Combinations",
  "c.d.specialDays": "Closures",
  "c.d.shifts": "Shifts",
  "c.d.policies": "Policies",
  "c.d.branding": "Branding",
  "c.d.emailTemplates": "Email wording",
  "c.d.added": "added",
  "c.d.changed": "changed",
  "c.d.removed": "removed",
  "c.s.name": "Name",
  "c.s.colour": "Colour",
  "c.s.first": "First seating",
  "c.s.last": "Last seating",
  "c.s.max_online": "Max online party",
  "c.s.default": "default",
  "c.s.remove": "Remove shift",
  "c.s.days": "Days",
  "c.s.plans": "Floor plans",
  "c.s.flow": "Flow control",
  "c.s.limit_arrivals": "Limit arrivals",
  "c.s.per": "per",
  "c.s.min": "{n} min",
  "c.s.max_covers": "Max covers",
  "c.s.max_parties": "Max parties",
  "c.s.none_ph": "none",
  "c.s.turn_times": "Turn times",
  "c.s.rules_one": "({n} rule)",
  "c.s.rules_other": "({n} rules)",
  "c.s.party_from": "Party from",
  "c.s.to": "to",
  "c.s.minutes": "Minutes",
  "c.s.add_turn": "+ Turn time",
  "c.s.take_res": "Tables that take reservations",
  "c.s.take_res_hint": "(uncheck to keep a table walk-in only)",
  "c.s.none": "No shifts yet.",
  "c.s.add": "+ Add shift",
  "c.s.new": "New shift",
  "c.s.remove_aria": "Remove",
  "c.t.label": "Label",
  "c.t.min": "Min",
  "c.t.max": "Max",
  "c.t.area": "Area",
  "c.t.plan": "Floor plan",
  "c.t.shape": "Shape",
  "c.t.shape.rect": "rect",
  "c.t.shape.round": "round",
  "c.t.shape.diamond": "diamond",
  "c.t.remove_aria": "Remove table {label}",
  "c.t.add": "+ Add table",
  "c.t.combos": "Combinations",
  "c.t.combos_hint": "Tables that can be pushed together for larger parties.",
  "c.t.combos_none": "None.",
  "c.t.add_combo": "+ Add combination",
  "c.p.name": "Name",
  "c.p.requires": "Requires",
  "c.p.kind.none": "Nothing",
  "c.p.kind.card_hold": "Card on file",
  "c.p.kind.deposit": "Deposit",
  "c.p.amount": "Amount",
  "c.p.per_guest": "per guest",
  "c.p.flat": "flat",
  "c.p.any_ph": "any",
  "c.p.cutoff": "Free cancellation until (hours before)",
  "c.p.charge_on": "Charge on",
  "c.p.on.both": "no-show and late cancel",
  "c.p.on.no_show": "no-show only",
  "c.p.on.late_cancel": "late cancel only",
  "c.p.message": "Message shown to the guest (default language)",
  "c.p.message_in": "Message in {language}",
  "c.p.no_payment": "No payment is taken.",
  "c.p.summary": "Guests of {from}{to} pay {amount}{each}.",
  "c.p.each": " each",
  "c.p.none": "No policies. Bookings need no card or deposit.",
  "c.p.add": "+ Add policy",
  "c.p.new": "New policy",
  "c.cl.date": "Date",
  "c.cl.title": "Title",
  "c.cl.title_ph": "Holiday",
  "c.cl.closed": "Closed",
  "c.cl.add": "+ Add date",
  "c.st.interval": "Slot interval (minutes)",
  "c.st.turn": "Default turn time (minutes)",
  "c.st.large": "Large party from",
  "c.st.off_ph": "off",
  "c.st.release": "New days open at",
  "c.st.wl_from": "Waitlist party from",
  "c.st.wl_to": "to",
  "c.st.emails": "Email guests a confirmation, and notices when a booking changes or is cancelled",
  "c.st.reminder": "Reminder",
  "c.st.rem.0": "Off",
  "c.st.rem.2": "2 hours before",
  "c.st.rem.4": "4 hours before",
  "c.st.rem.12": "12 hours before",
  "c.st.rem.24": "1 day before",
  "c.st.rem.48": "2 days before",
  "c.st.language": "Default language",
  "c.st.offered": "Languages offered to guests",
  "c.st.language_hint": "The default is what guests see first and what emails use when they chose no language.",
  "c.st.quick_hint": "Online on/off, party range, booking horizon and same-day cutoff stay in the quick settings; they take effect immediately.",
  "c.h.version": "Version",
  "c.h.published": "Published",
  "c.h.by": "By",
  "c.h.note": "Note",
  "c.h.live": "live",
  "c.h.restore": "Restore as draft",
  "c.h.hint": "Restoring creates a draft you can review; nothing changes until you publish it.",
  "c.b.intro": "How your restaurant looks on the booking page and in guest emails.",
  "c.b.accent": "Accent colour",
  "c.b.logo": "Logo address (https)",
  "c.b.logo_hint": "A link to an image on your own site. It is loaded from there, so keep it small.",
  "c.b.phone": "Phone",
  "c.b.address": "Address",
  "c.b.website": "Website (https)",
  "c.b.footer": "Closing note in {language}",
  "c.b.footer_hint": "Shown at the end of every email, for example parking or dress code.",
  "c.b.wording": "Email wording",
  "c.b.wording_hint": "Leave a field empty to use the standard text. Placeholders: {guest} {restaurant} {when} {party} {code} (and {fee} in cancellations).",
  "c.b.kind": "Email",
  "c.b.kind.confirmation": "Confirmation",
  "c.b.kind.reminder": "Reminder",
  "c.b.kind.change": "Change notice",
  "c.b.kind.cancellation": "Cancellation",
  "c.b.language": "Language",
  "c.b.subject": "Subject",
  "c.b.lead": "Opening text",
  "c.b.reset": "Use standard text",
  "c.b.preview": "Preview",
  "c.b.preview_failed": "The preview could not be created. Check the highlighted values.",
  "c.b.preview_fee": "Show with a fee",
  "c.b.preview_policy": "Show card terms",
  "c.b.subject_label": "Subject:",
  "l.feature.wall": "Wall",
  "l.feature.door": "Door",
  "l.feature.window": "Window",
  "l.feature.pillar": "Pillar",
  "l.feature.label": "Label",
  "l.combo.title": "Table combination for parties of {min} to {max}",
  "l.rotate_title": "Rotate (Alt = free)",
  "l.plan_aria": "Floor plan",
  "l.add_plan_title": "Add a floor plan",
  "l.add_plan": "+ Plan",
  "l.rename": "Rename",
  "l.del_plan": "Delete plan",
  "l.del_plan_title": "A plan can be removed once it is empty",
  "l.undo": "Undo",
  "l.redo": "Redo",
  "l.add_table": "+ Table",
  "l.add": "Add:",
  "l.draw_wall": "Draw wall",
  "l.draw_wall_title": "Click and drag to draw a wall (Esc to stop)",
  "l.snap": "Snap",
  "l.zoom": "Zoom",
  "l.zoom_out": "Zoom out",
  "l.zoom_in": "Zoom in",
  "l.zoom_reset": "Reset zoom",
  "l.canvas_aria": "Floor plan canvas. Arrow keys move the selection.",
  "l.help": "Click to select, Shift/Ctrl-click or drag a box to select several, drag to move, corner to resize, round handle to rotate, arrows nudge (Shift = larger), R rotates, Delete removes, Ctrl+A selects all, Ctrl+wheel zooms, Alt turns snapping off.",
  "l.overlap_one": "{n} table overlaps.",
  "l.overlap_other": "{n} tables overlap.",
  "l.insp_empty": "Select a table or fixture to edit it. Shift-click or drag a box to select several. Select two or more tables to combine them for large parties.",
  "l.selected": "{n} selected",
  "l.align": "Align",
  "l.align.left": "Left",
  "l.align.hcenter": "Center",
  "l.align.right": "Right",
  "l.align.top": "Top",
  "l.align.vcenter": "Middle",
  "l.align.bottom": "Bottom",
  "l.space": "Space evenly",
  "l.space_h": "Horizontally",
  "l.space_v": "Vertically",
  "l.rotate": "Rotate",
  "l.combine": "⛓ Combine tables",
  "l.combine_title": "Make these tables bookable together for larger parties",
  "l.duplicate": "Duplicate",
  "l.delete": "Delete",
  "l.rotation": "Rotation",
  "l.rotate_left": "Rotate left",
  "l.rotate_right": "Rotate right",
  "l.text": "Text",
  "l.length": "Length",
  "l.thickness": "Thickness",
  "l.in_combos": "In combinations",
  "l.table": "Table {label}",
  "l.table_aria": "Table {label}, {min} to {max} seats",
  "l.label": "Label",
  "l.min_seats": "Min seats",
  "l.max_seats": "Max seats",
  "l.area": "Area",
  "l.area_none": "None",
  "l.shape": "Shape",
  "l.shape.rect": "rect",
  "l.shape.round": "round",
  "l.shape.diamond": "diamond",
  "l.width": "Width",
  "l.height": "Height",
  "l.auto_size": "Auto size",
  "l.auto_size_title": "Size from the number of seats",
  "l.c.title": "Table combination",
  "l.c.hint": "Tables that are pushed together for a larger party. Seats up to {n} in total.",
  "l.c.from": "Party from",
  "l.c.to": "to",
  "l.c.tables": "Tables",
  "l.c.remove_aria": "Remove table {label} from this combination",
  "l.c.add": "Add a table",
  "l.c.choose": "Choose…",
  "l.c.delete": "Delete combination",
  "l.c.exists": "Those tables are already a combination.",
  "l.plan_prompt": "Name of the new floor plan",
  "l.plan_default": "Floor {n}",
  "l.plan_added": "Plan added and included in all shifts. Change this per shift in the Shifts section.",
  "l.plan_rename": "Rename floor plan",
  "c.p.title": "Restaurant profile",
  "c.p.hint": "Shown on your booking page. Guests see a short introduction and your photos before they choose a time.",
  "c.p.cuisines": "Cuisines (comma separated, up to 5)",
  "c.p.check": "Typical check",
  "c.p.check_ph": "e.g. €25–40 per person",
  "c.p.description": "Description ({language})",
  "c.p.gallery": "Photos",
  "c.p.gallery_hint": "Up to 8 photos, PNG, JPEG, WebP or GIF, each up to 1 MB. They appear in this order.",
  "c.p.photo_add": "Add photo…",
  "c.p.remove": "Remove",
  "c.p.left": "Move left",
  "c.p.right": "Move right",
  "c.p.big": "That photo is larger than 1 MB. Please choose a smaller one.",
  "x.title": "More",
  "x.more": "More",
  "x.more_title": "Private dining, table alerts, menus, campaigns and integrations",
  "x.tab.private": "Private dining",
  "x.tab.alerts": "Table alerts",
  "x.tab.menus": "Menus",
  "x.tab.marketing": "Campaigns",
  "x.tab.integrations": "Integrations",
  "x.saved": "Saved.",
  "x.edit": "Edit",
  "x.cancel": "Cancel",
  "x.active": "Active",
  "x.pd.requests": "Event requests",
  "x.pd.when": "When",
  "x.pd.who": "Who",
  "x.pd.guests": "Guests",
  "x.pd.room": "Room",
  "x.pd.status": "Status",
  "x.pd.quote": "Quote",
  "x.pd.deposit": "Deposit",
  "x.pd.none": "No requests yet. Guests can ask for an event from your booking page once you have added a room.",
  "x.pd.mail_hint": "Changing a status to Quoted, Confirmed or Declined also emails the guest. A quote needs an amount.",
  "x.pd.s.new": "New",
  "x.pd.s.quoted": "Quoted",
  "x.pd.s.confirmed": "Confirmed",
  "x.pd.s.declined": "Declined",
  "x.pd.s.cancelled": "Cancelled",
  "x.pd.rooms": "Rooms",
  "x.pd.rooms_hint": "A room with a guest range is offered on the booking page as a private event request. Rooms are separate from the floor plan.",
  "x.pd.room_name": "Name",
  "x.pd.room_new": "New room…",
  "x.pd.min": "Min.",
  "x.pd.max": "Max.",
  "x.pd.room_del": "Delete this room? Requests keep their details.",
  "x.al.hint": "Guests who found a day full can ask to be told when a table opens up. Guests with a priority tag hear first; everyone else after 15 minutes.",
  "x.al.none": "No alerts.",
  "x.al.priority": "Priority",
  "x.al.s.waiting": "Waiting",
  "x.al.s.notified": "Told",
  "x.al.s.closed": "Closed",
  "x.mn.new": "New menu",
  "x.mn.edit": "Edit menu",
  "x.mn.title": "Title",
  "x.mn.body": "Content",
  "x.mn.format": "One line per dish: name | price | description | labels (labels separated by commas, such as vegan). A line starting with # begins a new section. Keep the same order in every language.",
  "x.mn.active": "Show on the booking page",
  "x.mn.shown": "Shown",
  "x.mn.hidden": "Hidden",
  "x.mn.items": "dishes",
  "x.mn.none": "No menus yet.",
  "x.mn.del": "Delete this menu?",
  "x.mk.new": "New campaign",
  "x.mk.hint": "Only guests who agreed to marketing emails receive this, and every email has an unsubscribe link. Write {first_name} to greet each guest by name.",
  "x.mk.subject": "Subject",
  "x.mk.body": "Message",
  "x.mk.tag": "Only guests tagged",
  "x.mk.any": "everyone",
  "x.mk.min_visits": "At least this many visits",
  "x.mk.not_seen": "Not seen for (days)",
  "x.mk.preview": "Count recipients",
  "x.mk.count": "{n} recipients",
  "x.mk.send": "Send campaign",
  "x.mk.fill": "Enter a subject and a message.",
  "x.mk.confirm": "Send this email to {n} guests?",
  "x.mk.done": "Sent to {n} guests.",
  "x.mk.sent": "Sent campaigns",
  "x.mk.recipients": "Recipients",
  "x.mk.delivered": "Delivered",
  "x.mk.none": "No campaigns yet.",
  "x.in.keys": "API keys",
  "x.in.keys_hint": "For your own systems. A read key can look at reservations and reports; a read and write key can also create and change reservations. Keys never reach settings, staff, billing or guest data.",
  "x.in.name": "Name",
  "x.in.scope": "Access",
  "x.in.scope.read": "Read only",
  "x.in.scope.write": "Read and write",
  "x.in.last_used": "Last used",
  "x.in.revoked": "Revoked",
  "x.in.revoke": "Revoke",
  "x.in.key_new": "New key name…",
  "x.in.revoke_confirm": "Revoke this key? Systems using it stop working.",
  "x.in.key_made": "API key \"{name}\" created. Copy it now:",
  "x.in.once": "It is shown only once and cannot be looked up later.",
  "x.in.hooks": "Webhooks",
  "x.in.hooks_hint": "We send a signed message to your address when a reservation is created, changed, seated or cancelled. Check the x-webhook-signature header with the secret shown when you add the address.",
  "x.in.url": "Address (https)",
  "x.in.events": "Events",
  "x.in.all_events": "All reservation events and waitlist additions",
  "x.in.test": "Send test",
  "x.in.hook_made": "Webhook added. The signing secret is:",
  "x.in.hook_del": "Remove this webhook address?",
  "x.in.failed": "{n} failed",
  "x.in.log": "Recent deliveries",
  "x.in.log_none": "Nothing sent yet.",
  "x.in.d.pending": "Waiting",
  "x.in.d.sent": "Delivered",
  "x.in.d.failed": "Failed",
  "x.card.take": "Take the guest's card now",
  "x.card.hint": "The guest reads the card out; it goes straight to the payment provider and is never stored here.",
  "x.card.title": "Card for this booking",
  "x.card.go": "Charge card and book",
  "x.card.hold_note": "No money is taken now; the card is saved for fees.",
  "x.card.deposit_note": "{amount} is charged now as a deposit.",
  "x.card.changed": "The time or party size changed. Press the button again to hold the new time.",
  "x.card.none": "This time needs no card.",
  "x.card.failed": "The card was not accepted.",
  "x.card.test": "Test mode: no card details are needed.",
  "x.card.not_ready": "The card field is not ready yet.",
  "x.access.title": "Access",
  "x.access.code": "Access code (hides the offer until guests enter it)",
  "x.access.tags": "Only for guests tagged (comma separated)",
  "x.tag.priority": "Priority: hears about open tables first",
  "n.menu": "Menu",
  "n.close": "Close menu",
  "n.change": "Change",
  "n.front": "Front of house",
  "n.planning": "Availability planning",
  "n.floorplan": "Floor plans",
  "n.private": "Private dining",
  "n.reporting": "Reporting",
  "n.menus": "Menus",
  "n.marketing": "Marketing",
  "n.alerts": "Table alerts",
  "n.guests": "Guests",
  "n.notes": "Shift notes",
  "n.admin": "Admin",
  "n.profile": "Restaurant profile",
  "n.settings": "Restaurant settings",
  "n.policies": "Policies",
  "n.widget": "Booking page",
  "n.integrations": "Integrations",
  "n.accounts": "Accounts",
  "n.billing": "Billing",
  "n.security": "Security",
  "n.log": "Activity log",
  "n.signout": "Sign out",
  "n.id": "Restaurant ID {id}",
  "x.pd.reqs_none_room": "No room chosen",
  "x.pd.save_room": "Save room",
  "c.sec.schedule": "Schedule",
  "c.sec.experiences": "Experiences",
  "c.w.show_menus": "Show my menus on the booking page",
  "c.st.channels": "Contact channels",
  "c.st.sms": "Send text messages to guests (table ready, running late)",
  "c.st.sms_hint": "Off by default. Texts need the guest's consent; check the rules in your country before you switch this on. You also need a text provider connected to the server.",
  "c.st.marketing": "Marketing emails and the marketing consent box",
  "c.st.marketing_hint": "Off by default. When off, the booking page does not ask for marketing consent and campaigns cannot be sent. Switch on only if you want to send newsletters and have the consent wording checked for your country.",
  "x.cal.title": "Room calendar",
  "x.cal.none": "No events this month.",
  "x.cal.no_room": "No room yet",
  "x.cal.prev": "Previous month",
  "x.cal.next": "Next month",
  "r.sales.title": "Sales",
  "r.sales.none": "No sales data yet. Connect your point of sale under Integrations; the closed checks it sends appear here.",
  "r.sales.revenue": "Revenue",
  "r.sales.checks_n": "{n} checks",
  "r.sales.avg_check": "Average check",
  "r.sales.per_cover": "Per guest",
  "r.sales.matched": "{n} matched to reservations",
  "r.sales.tips": "Tips",
  "r.sales.by_day": "Revenue by day",
  "r.sales.by_source": "Revenue by booking source",
  "r.sales.unmatched": "Not matched to a reservation",
  "x.in.pos": "Point of sale",
  "x.in.pos_hint": "Every point of sale works differently, so there is one plain way in: your POS (or a small script next to it) sends closed checks to the address below with a read-and-write API key. Sending the same check again updates it. Add reservationCode to match a check to a reservation.",
  "x.in.pos_example": "Example",
  "h.x.search_results": "Search results",
  "c.b.kind.review": "Thank you and review request",
  "c.b.review_url": "Review link (for example your Google review page)",
  "c.b.review_hint": "Guests who agreed to marketing email get a thank-you with this link two hours after their visit. Needs marketing switched on under Settings.",
  "c.b.accent_warn": "This colour is too light for white button text (contrast {ratio}:1, at least 4.5:1 is needed). Guests with weak eyesight may struggle to read it.",
  "n.print": "Day list and table cards",
  "pr.title": "Print for the floor",
  "pr.hint": "Opens a PDF in a new tab. Print it from there.",
  "pr.date": "Day",
  "pr.shift": "Shift",
  "pr.all_shifts": "All shifts",
  "pr.list": "Day list",
  "pr.list_hint": "All reservations in time order, with table, guests, phone and notes. A tick box per line to work through each shift.",
  "pr.cards": "Table cards (booked tables)",
  "pr.cards_hint": "One card per booked table, 8 per page. Cut out and put on the table, or write on them.",
  "pr.cards_all": "Table cards (all tables)",
  "pr.cards_all_hint": "Also a blank card for every free table, with lines to write the guest name.",
  "pr.open": "Open PDF",
  "c.st.daily": "Daily printouts",
  "c.st.daily_time": "Email the day list and table cards at",
  "c.st.daily_off": "Off",
  "c.st.daily_hint": "Sent every day at this time to the notification addresses above, as two PDFs. Needs email sending to be set up on the server.",
  "c.sec.widget": "Booking page",
  "c.b.logo_upload": "Logo image",
  "c.b.logo_choose": "Upload logo…",
  "c.b.logo_replace": "Replace logo…",
  "c.b.logo_remove": "Remove logo",
  "c.b.logo_none": "No logo uploaded yet.",
  "c.b.logo_uploading": "Uploading…",
  "c.b.logo_ready": "Logo uploaded. It goes live when you publish.",
  "c.b.logo_rules": "PNG, JPEG, WebP or GIF, up to 512 KB. A wide image on a transparent or white background works best.",
  "c.b.logo_or_link": "Or use a link to an image (https)",
  "c.b.logo_big": "That image is larger than 512 KB. Please choose a smaller one.",
  "c.w.intro": "Make the booking page look and work the way your restaurant needs. The preview shows your unpublished changes.",
  "c.w.look": "Look",
  "c.w.texts": "Texts",
  "c.w.fields": "What guests are asked",
  "c.w.behaviour": "Behaviour",
  "c.w.css": "Custom CSS",
  "c.w.embed": "Put it on your website",
  "c.w.theme": "Theme",
  "c.w.theme.light": "Light",
  "c.w.theme.dark": "Dark",
  "c.w.theme.auto": "Follow the guest's device",
  "c.w.accent": "Accent colour (buttons, headings)",
  "c.w.background": "Page background",
  "c.w.panel": "Panels",
  "c.w.text": "Text colour",
  "c.w.theme_default": "Use the theme's colour",
  "c.w.font": "Font",
  "c.w.font.system": "Modern (system)",
  "c.w.font.serif": "Classic serif",
  "c.w.font.rounded": "Friendly rounded",
  "c.w.font.mono": "Typewriter",
  "c.w.radius": "Corner roundness",
  "c.w.width": "Width",
  "c.w.width.narrow": "Narrow",
  "c.w.width.normal": "Standard",
  "c.w.width.wide": "Wide",
  "c.w.button": "Buttons",
  "c.w.button.solid": "Filled",
  "c.w.button.outline": "Outlined",
  "c.w.align": "Heading",
  "c.w.align.left": "Left",
  "c.w.align.center": "Centred",
  "c.w.show_logo": "Show the logo",
  "c.w.show_name": "Show the restaurant name",
  "c.w.title": "Heading in {language}",
  "c.w.title_hint": "Replaces the restaurant name above the form. Empty keeps the name.",
  "c.w.intro_text": "Welcome text in {language}",
  "c.w.confirm_label": "Booking button in {language}",
  "c.w.thanks": "Message after booking in {language}",
  "c.w.phone": "Phone number",
  "c.w.phone.hidden": "Do not ask",
  "c.w.phone.optional": "Optional",
  "c.w.phone.required": "Required",
  "c.w.occasion": "Ask for the occasion",
  "c.w.request": "Ask for special requests",
  "c.w.marketing": "Offer the newsletter checkbox",
  "c.w.sms": "Offer the text-message checkbox",
  "c.w.area": "Let guests choose indoor or outdoor seating",
  "c.w.default_party": "Preselected party size",
  "c.w.days_shown": "Days of times shown at once",
  "c.w.time_from": "Time list starts at",
  "c.w.time_to": "Time list ends at",
  "c.w.behaviour_hint": "Guests still only see times that are really available.",
  "c.w.css_hint": "For anything the options above do not cover. Loading images, fonts or other files is not allowed. Useful hooks: .brand, .card, .slot, button.primary, h1, h2, and the variables --brand, --bg, --panel, --ink, --radius.",
  "c.w.css_bad": "The custom CSS may not load other files (url, @import) or contain markup.",
  "c.w.preview": "Preview",
  "c.w.preview_lang": "Preview language",
  "c.w.embed_hint": "Paste this where the booking form should appear. It adjusts its height by itself.",
  "c.w.embed_link": "Direct link",
  "c.w.embed_copy": "Copy",
  "c.w.embed_copied": "Copied.",
  "c.w.embed_published": "The page shows what you have published; unpublished changes appear only in the preview.",
  "c.d.name": "Restaurant name",
  "c.b.business": "Your business",
  "c.b.business_hint": "Used on the booking page, in every email and in the dashboard. Change the name here and it changes everywhere once published.",
  "c.b.name": "Restaurant name",
  "c.b.legal": "Company name (optional)",
  "c.b.contact_email": "Contact email",
  "c.w.looks": "Ready-made looks",
  "c.w.looks_hint": "One click sets colours, fonts, texts and email wording. Your name, logo and contact details are kept, and you can still change everything afterwards.",
  "c.w.look_apply": "Use this look",
  "c.w.look_confirm": "Apply \"{name}\"? This replaces the colours, fonts, texts, field choices and email wording in your draft. Your logo and business details stay.",
  "c.w.look_applied": "\"{name}\" applied to your draft. Review it, then publish.",
  "c.w.look_share": "Copy a look to another restaurant",
  "c.w.look_json_hint": "Export this restaurant's look as text, paste it into another restaurant's editor and import it there.",
  "c.w.look_export": "Export look",
  "c.w.look_import": "Import look",
  "c.w.look_bad": "That text is not a valid look.",
  "c.w.look_imported": "Look imported into your draft.",
  "c.sec.areas": "Areas",
  "c.a.intro": "Areas are the parts of your restaurant guests can choose between, for example a separee, a smoking area or a terrace. Create as many as you need, then give tables to them on the floor plan.",
  "c.a.quick": "Quick add:",
  "c.a.add": "+ New area",
  "c.a.none": "No areas yet. Tables without an area are still bookable; guests are just not offered a choice.",
  "c.a.name": "Name",
  "c.a.kind": "Type",
  "c.a.bookable": "Guests can choose it online",
  "c.a.texts": "Names and descriptions per language",
  "c.a.texts_hint": "Leave empty to use the name above. The description appears under the seating choice on the booking page, for example \"Smoking allowed, heated\".",
  "c.a.name_in": "Name in {language}",
  "c.a.desc_in": "Description in {language}",
  "c.a.tables_one": "{n} table",
  "c.a.tables_other": "{n} tables",
  "c.a.place": "Place tables on the floor plan",
  "c.a.delete": "Delete area",
  "c.a.delete_confirm": "Delete the area \"{name}\"? Its tables stay, but no longer belong to any area.",
  "l.dup_plan": "Copy plan",
  "l.dup_plan_title": "Copy this floor plan with its tables, walls and combinations, for example for a second floor",
  "l.dup_plan_name": "{name} (copy)",
  "l.move_to_plan": "Move to floor plan",
  "l.bulk_area": "Area for all selected",
  "l.bulk_keep": "— keep as is —",
  "h.plans_aria": "Floor plans",
  "l.fp.title": "Floor plan",
  "l.fp.plan_aria": "Choose a floor plan",
  "l.fp.new_plan": "+ New floor plan…",
  "l.fp.elements": "Elements",
  "l.fp.room": "Room",
  "l.fp.elements_hint": "Click an element to add it, or drag it onto the plan.",
  "l.fp.toolbar": "Floor plan tools",
  "l.fp.zoom_out": "Zoom out",
  "l.fp.zoom_fit": "Fit the plan to the window",
  "l.fp.tool_select": "Select and move",
  "l.fp.tool_pan": "Move the view",
  "l.fp.rotate_left": "Rotate left",
  "l.fp.rotate_right": "Rotate right",
  "l.fp.tables": "Tables",
  "l.fp.locate": "Show all tables",
  "l.fp.start": "Select and drag a table to get started",
  "l.fp.areas": "Dining areas",
  "l.fp.new": "New",
  "l.fp.no_areas": "No dining areas yet.",
  "l.fp.plans": "Floor plans",
  "l.fp.tables_n_one": "{n} table",
  "l.fp.tables_n_other": "{n} tables",
  "l.fp.plans_n_one": "{n} floor plan",
  "l.fp.plans_n_other": "{n} floor plans",
  "l.fp.el_one": "{shape}, {n} seat",
  "l.fp.el_other": "{shape}, {n} seats",
  "l.fp.area_prompt": "Name of the new dining area",
  "l.fp.area_added": "Dining area added. Select tables and choose it in the panel on the right.",
  "l.fp.area_empty": "No tables in this area yet.",
  "h.invoices": "Invoices",
  "h.invoices_title": "Your subscription invoices",
  "h.inv.title": "Invoices",
  "h.inv.intro": "The invoices and credit notes for your subscription. Each has its legal number and can be downloaded as a PDF.",
  "h.inv.empty": "No invoices have been issued yet.",
  "h.inv.number": "Number",
  "h.inv.period": "Period",
  "h.inv.date": "Date",
  "h.inv.due": "Due",
  "h.inv.amount": "Amount",
  "h.inv.status": "Status",
  "h.inv.pdf": "PDF",
  "h.inv.credit_note": "Credit note",
  "h.inv.status.open": "Open",
  "h.inv.status.paid": "Paid",
  "h.inv.status.credited": "Credited",
  "h.inv.status.issued": "Issued",
  "h.inv.method": "Payment method on file: {method}",
  "h.d.erase": "Erase this guest's personal data",
  "h.d.erase_confirm": "Erase this guest's name, contact details, notes and requests from every visit? The visits stay in your statistics but no longer identify anyone. This cannot be undone.",
  "h.d.erased": "The guest's personal data was erased.",
  "perm.guests.manage": "See and edit the guest book, tags and notes, export guests",
  "perm.reports.view": "See reports and export reservations",
  "h.x.notes": "Notes",
  "h.x.notes_title": "Notes and summary for this day",
  "h.x.guests": "Guests",
  "h.x.guests_title": "Guest book, tags and export",
  "h.x.reports": "Reports",
  "h.x.reports_title": "Reports and exports",
  "h.x.search_ph": "Search name, phone or code",
  "h.x.no_results": "No matches.",
  "h.x.quotes": "Wait quote by party size",
  "h.x.quote_title": "Party of {n}: about {m} minutes. Tap to add to the waitlist.",
  "h.x.referral": "Referral",
  "h.x.referral_ph": "Who recommended us?",
  "h.x.visit_note": "Visit note",
  "h.x.tags": "Tags",
  "h.x.sms_ready": "Text: table ready",
  "h.x.sms_custom": "Send text…",
  "h.x.sms_no_consent": "No consent for text messages.",
  "h.x.sms_prompt": "Message to the guest (up to 300 characters)",
  "h.x.sms_sent": "Text sent. {n} left this month.",
  "h.x.guestbook": "Guest book",
  "h.x.history": "History",
  "h.x.no_history": "Nothing recorded yet.",
  "h.x.upcoming": "Upcoming",
  "h.x.visits": "Visits",
  "h.x.cancellations": "Cancellations",
  "h.x.noshows": "No-shows",
  "h.x.status_quick": "Change status",
  "h.x.schedule": "Schedule for this table",
  "h.x.find_guest": "Find a guest",
  "h.x.find_guest_ph": "Name, phone or email",
  "h.x.no_guest": "No guest found. Fill in the details below to add one.",
  "h.x.below_min": "Below table minimum",
  "h.x.exceeds_max": "Exceeds table maximum",
  "h.x.table_free": "This table is free at {time}.",
  "h.x.table_busy": "This table is already booked around {time}.",
  "h.x.covers_at": "Covers at this time: {covers}",
  "h.x.add_note": "Add a note",
  "h.x.note_title": "Title",
  "h.x.note_scope": "Applies to",
  "h.x.note_body": "Details",
  "h.x.note_event": "This is a special event",
  "h.x.all_day": "All day",
  "h.x.no_notes": "No notes for this day.",
  "h.x.kind.event": "Event",
  "h.x.kind.general": "Note",
  "h.x.delete": "Delete",
  "h.x.shift_summary": "What the shift should know",
  "h.x.sum_large": "Large parties",
  "h.x.sum_requests": "Guest requests",
  "h.x.sum_visit": "Visit notes",
  "h.x.sum_events": "Special occasions",
  "h.x.ev.reservation.create": "Booked",
  "h.x.ev.reservation.modify": "Changed",
  "h.x.ev.reservation.cancel": "Cancelled",
  "h.x.ev.reservation.no_show": "Marked no-show",
  "h.x.ev.reservation.seat": "Seated",
  "h.x.ev.reservation.move": "Moved",
  "h.x.ev.reservation.preassign": "Table assigned",
  "h.x.ev.reservation.status": "Status changed",
  "h.x.ev.reservation.update": "Details updated",
  "h.x.ev.sms.sent": "Text sent",
  "h.x.ev.guest.erased": "Guest data erased",
  "h.x.ev.walkin.seat": "Walk-in seated",
  "g.title": "Guest book",
  "g.tab.guests": "Guests",
  "g.tab.tags": "Tags",
  "g.search": "Search name, email, phone or company",
  "g.tag": "Tag",
  "g.all_tags": "All",
  "g.sort": "Sort by",
  "g.sort.name": "Name",
  "g.sort.visits": "Most visits",
  "g.sort.last_visit": "Last visit",
  "g.sort.created": "Newest",
  "g.count": "{n} guests",
  "g.new": "New guest",
  "g.export": "Export CSV",
  "g.none": "No guests yet.",
  "g.col.name": "Name",
  "g.col.contact": "Contact",
  "g.col.visits": "Visits",
  "g.col.upcoming": "Upcoming",
  "g.col.cancellations": "Cancellations",
  "g.col.noshows": "No-shows",
  "g.col.last": "Last visit",
  "g.col.tags": "Tags",
  "g.first": "First name",
  "g.last": "Last name",
  "g.phone": "Phone",
  "g.email": "Email",
  "g.company": "Company",
  "g.marketing": "Agreed to email marketing",
  "g.sms": "Agreed to text updates",
  "g.note.general": "General notes",
  "g.note.relationship": "Special relationship",
  "g.note.food_drink": "Food and drink",
  "g.note.seating": "Seating preferences",
  "g.hide": "Hide guest",
  "g.unhide": "Show guest again",
  "g.history": "Visits",
  "g.no_history": "No visits yet.",
  "g.saved": "Guest saved.",
  "g.tags_hint": "Manual tags are set on a guest. Give a tag a number of visits to apply it automatically to everyone with at least that many visits.",
  "g.tag_name": "Name",
  "g.tag_color": "Colour",
  "g.tag_auto": "Automatic from visits",
  "g.tag_new": "New tag",
  "g.manual": "Manual",
  "g.add": "Add",
  "g.delete": "Delete",
  "g.delete_confirm": "Delete this tag? It is removed from every guest.",
  "r.title": "Reports",
  "r.from": "From",
  "r.to": "To",
  "r.last": "Last {n} days",
  "r.export": "Export reservations (CSV)",
  "r.none": "No data.",
  "r.no_data": "No data in this period.",
  "r.covers": "Covers",
  "r.vs_prev": "{d} vs the period before",
  "r.parties": "Parties",
  "r.walkins": "Walk-in covers",
  "r.noshows": "No-shows",
  "r.rate": "{p}% of bookings",
  "r.cancellations": "Cancellations",
  "r.first_time": "First-time guests",
  "r.repeat": "{n} returning",
  "r.lead": "Average lead time",
  "r.days": "{n} days",
  "r.by_day": "Covers per day",
  "r.by_source": "Covers by source",
  "r.by_size": "Parties by size",
  "r.by_weekday": "Average covers by weekday",
  "r.by_shift": "Covers by shift (reserved + walk-in)",
  "r.reserved": "Reserved",
  "r.walkin": "Walk-in",
  "r.avg": "avg",
  "r.turn": "Turn times",
  "r.party": "Party",
  "r.actual": "Actual",
  "r.planned": "Planned",
  "r.diff": "Difference",
  "r.min": "min",
  "r.turn_hint": "Actual is the time from seating to finishing. If it is often longer than planned, raise the turn time in Configuration → Shifts.",
  "r.footnote_one": "Covers count guests in reservations that were not cancelled and not no-shows. One party in this period.",
  "r.footnote_other": "Covers count guests in reservations that were not cancelled and not no-shows. {n} parties in this period.",
  "c.st.horizon": "Guests can book up to (days ahead)",
  "c.st.horizon_hint": "New days open at the release time below. The last bookable day today is {date}.",
  "c.st.notify": "Notify these email addresses",
  "c.st.notify_hint": "Separate several addresses with commas. They get a short email when an event below happens.",
  "c.st.notify_ev.new_online": "New online reservation",
  "c.st.notify_ev.cancellation": "Guest cancellation",
  "c.st.notify_ev.large_party": "Large party",
  "c.w.terms": "Terms and conditions",
  "c.w.terms_required": "Guests must accept the terms before booking",
  "c.w.terms_text": "Wording next to the checkbox in {language}",
  "c.w.terms_hint": "For example \"I accept the house rules and the cancellation terms.\" Without text in a language, a standard sentence is shown.",
  "c.cl.copy": "Copy",
  "c.cl.copy_title": "Copy this day, with its own shifts, to another date",
  "c.cl.copy_prompt": "Copy to which date? (YYYY-MM-DD)",
  "c.cl.copy_exists": "That date already has a special day.",
  "c.cl.range": "Close a date range…",
  "c.cl.holidays": "Add public holidays…",
  "c.cl.country": "Country",
  "c.cl.year": "Year",
  "c.cl.from": "From",
  "c.cl.to": "To",
  "c.cl.range_ph": "For example Summer break",
  "c.cl.range_apply": "Close these days",
  "c.cl.range_bad": "Choose a start and an end date, with the end not before the start.",
  "c.cl.have": "already added",
  "c.cl.hol_apply": "Add the selected holidays as closed days",
  "c.cl.hol_added": "{n} holidays added.",
  "c.cl.tools_hint": "Holidays are suggestions and do not include regional ones. Changes go live when you publish.",
  "c.sg.intro": "Your regular week at a glance. Drag a block up or down to move a shift, or its bottom edge to change the last seating. Click a block to edit it.",
  "c.sg.hint": "Click a shift to edit it, or add a new one.",
  "c.sg.hint_edit": "Changes apply to every day this shift runs.",
  "c.sg.add": "+ Add a shift",
  "c.sg.new": "New shift",
  "c.w.embed_auto": "Guest's language",
  "c.w.embed_height": "Height (px)",
  "c.w.qr_booking": "Booking page QR code",
  "c.w.qr_waitlist": "Waitlist QR code (guests join from their phone)",
  "c.w.qr_download": "Download SVG",
  "c.x.intro": "Experiences are special offers such as a tasting menu or brunch. Guests pick one on the booking page, and only times inside its window and party sizes are offered. Changes here take effect at once; they do not need publishing.",
  "c.x.add": "+ New experience",
  "c.x.none": "No experiences yet.",
  "c.x.new": "New experience",
  "c.x.saved": "Experience saved.",
  "c.x.delete_confirm": "Delete this experience? Existing bookings keep their reservation but lose the link to it.",
  "c.x.title": "Title in {language}",
  "c.x.desc": "Description in {language}",
  "c.x.price": "Price per guest",
  "c.x.start": "From",
  "c.x.end": "Until",
  "c.x.min_party": "Smallest party",
  "c.x.max_party": "Largest party",
  "c.x.max_covers": "Guests per day, at most",
  "c.x.unlimited": "No limit",
  "c.x.from": "Offered from",
  "c.x.to": "Offered until",
  "c.x.active": "Shown to guests",
  "h.y.feed": "Activity",
  "h.y.feed_title": "New and changed reservations",
  "h.y.feed_hint": "What guests and staff booked, changed or cancelled. A moved booking shows its old time struck through.",
  "h.y.feed_none": "Nothing yet.",
  "h.y.mark_seen": "Mark all as seen",
  "h.y.f.create": "booked",
  "h.y.f.modify": "changed",
  "h.y.f.cancel": "cancelled",
  "h.y.f.noshow": "did not come",
  "h.y.f.online": "online guest",
  "h.y.problems": "Problems",
  "h.y.problems_title": "Reservations that need attention",
  "h.y.problems_none": "Nothing needs attention right now.",
  "h.y.p.unassigned": "No table assigned, starts soon",
  "h.y.p.late": "Running late: {n} min past the time",
  "h.y.p.overdue": "Over the planned time by {n} min",
  "h.y.p.too_big": "The assigned table is too small",
  "h.y.audit": "Log",
  "h.y.audit_title": "Who did what",
  "h.y.audit_hint": "The most recent actions of staff and guests in this restaurant.",
  "h.y.when": "When",
  "h.y.who": "Who",
  "h.y.what": "What",
  "h.y.ref": "Reference",
  "h.y.switch": "Switch restaurant",
  "h.y.asof_title": "See the floor at another time",
  "h.y.asof_hint": "Shows which tables will be taken at that time, from the bookings. It does not change anything.",
  "h.y.asof_now": "Now",
  "h.y.asof_show": "Show",
  "h.y.update_status": "Update status",
  "h.y.change": "Change the booking",
  "h.y.change_time": "Change the time",
  "h.y.change_party": "Change the party size",
  "h.y.change_duration": "Change the duration",
  "h.y.experience": "Experience",
  "h.y.no_experience": "None",
  "h.y.send_confirmation": "Send the standard booking confirmation",
  "h.y.to_waitlist": "Add to the waitlist instead",
  "h.y.find_times": "Show available times",
  "h.y.confirm_table": "Confirm table",
  "h.y.confirm": "Confirm",
  "h.y.avail_free": "Table {label} is free.",
  "h.y.avail_until": "Table {label} is free now, until {time}.",
  "h.y.avail_next": "Table {label} is free; its next booking is at {time}.",
  "h.y.avail_busy": "Table {label} is occupied right now.",
  "h.y.avail_blocked": "Table {label} is blocked.",
  "h.y.next_to_seat": "Next to seat:",
  "h.y.min_ago": "{n} min ago",
  "h.y.cal_legend": "Covers: regular · walk-in · ★ experiences",
} as const;
